import { useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "../context/AuthContext";

const KEY = "dss_rooms";
const local = () => JSON.parse(localStorage.getItem(KEY) || "[]");

export function useRooms() {
  const { user } = useAuth();
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    if (user) api.get("/me/rooms").then((r) => setRooms(r.data)).catch(() => setRooms([]));
    else setRooms(local());
  }, [user]);
  const save = async (room) => {
    if (user) { const r = await api.post("/me/rooms", room); setRooms((x) => [...x, r.data]); return r.data; }
    const r = { ...room, id: String(Date.now()) };
    const next = [...local(), r].slice(-10);
    localStorage.setItem(KEY, JSON.stringify(next)); setRooms(next); return r;
  };
  const remove = async (id) => {
    if (user) await api.delete(`/me/rooms/${id}`);
    else localStorage.setItem(KEY, JSON.stringify(local().filter((r) => r.id !== id)));
    setRooms((x) => x.filter((r) => r.id !== id));
  };
  return { rooms, save, remove };
}
